import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';

export class ClientPortalLoginAdapter extends BaseHttpAdapter {}
